import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  archives: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  totalFileSize: 0, // Stores total file size
  totalTrashedFiles: 0, // Stores total trashed files count
  totalTrashedArchives: 0, // Stores total trashed archives count
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "archive",
  initialState,
  reducers: {
    getArchiveSuccess: (state, action) => {
      state.archives.data = action.payload.data; // Store archives data
      state.totalFileSize = action.payload.totalFileSize; // Store total file size
      state.totalTrashedFiles = action.payload.totalTrashedFiles; // Store total trashed files
      state.totalTrashedArchives = action.payload.totalTrashedArchives; // Store total trashed archives
      state.loading = false;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getArchives = ({ accessToken, filters = {} }) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoading());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-archives?startDate=${filters?.startDate}&&endDate=${filters?.endDate}&&fromButton=${filters?.fromButton}`,
        { headers }
      );
      dispatch(slice.actions.getArchiveSuccess(res.data)); // Dispatch full response
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};
